<template>
  <section class="stats-section" ref="statsRef">
    <div class="stats-bg" aria-hidden="true"></div>
    <div class="section-container">
      <div class="stats-row">
        <template v-for="(item, i) in items" :key="i">
          <div class="stats-item">
            <div class="stats-num" :class="{ animated: visible }">{{ item.number }}</div>
            <div class="stats-label">{{ item.label }}</div>
          </div>
          <div v-if="i < items.length - 1" class="stats-divider"></div>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({ config: { type: Object, default: () => ({}) } });

const DEFAULT_ITEMS = [
  { number: '2000+', label: 'طالب مسجّل' },
  { number: '350+', label: 'درس مسجّل' },
  { number: '95%', label: 'نسبة النجاح' },
  { number: '4', label: 'صفوف دراسية' },
];
const items = computed(() => (props.config.items?.length ? props.config.items : DEFAULT_ITEMS));

const statsRef = ref(null);
const visible = ref(false);

onMounted(() => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visible.value = true;
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });

  if (statsRef.value) observer.observe(statsRef.value);
});
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
.section-container { max-width:1200px;margin:0 auto;padding:0 2rem; }

.stats-section { padding:5rem 0;position:relative;overflow:hidden;background:linear-gradient(135deg,#0f0c29,#302b63); }
.stats-bg { position:absolute;inset:0;background:radial-gradient(ellipse at 50% 50%,rgba(91,95,239,.2) 0%,transparent 70%); }
.stats-row { display:flex;align-items:center;justify-content:center;gap:0;flex-wrap:wrap;position:relative;z-index:1; }
.stats-item { display:flex;flex-direction:column;align-items:center;gap:.4rem;padding:1.5rem 3rem;text-align:center; }
.stats-num { font-size:clamp(2rem,4vw,3rem);font-weight:900;color:#fff;opacity:0;transform:translateY(20px);transition:all .8s cubic-bezier(.4,0,.2,1);font-family:'Cairo',sans-serif; }
.stats-num.animated { opacity:1;transform:translateY(0); }
.stats-item:nth-child(3) .stats-num.animated { transition-delay:.1s; }
.stats-item:nth-child(5) .stats-num.animated { transition-delay:.2s; }
.stats-item:nth-child(7) .stats-num.animated { transition-delay:.3s; }
.stats-label { font-size:.9rem;color:rgba(255,255,255,.6);font-weight:500; }
.stats-divider { width:1px;height:60px;background:rgba(255,255,255,.1);align-self:center; }

@media(max-width:900px) { .stats-item { padding:1rem 1.5rem; } .stats-divider { height:40px; } }

/* ── Mobile app home: one compact LIGHT stat card (single row, ~80px) ── */
@media (max-width: 768px) {
  .stats-section { padding: .5rem 1rem .25rem; background: transparent; overflow: visible; }
  .stats-bg { display: none; }
  .section-container { padding: 0; }
  .stats-row {
    background: #fff;
    border: 1px solid rgba(17,24,39,.06);
    border-radius: 16px;
    box-shadow: 0 4px 14px rgba(17,24,39,.05);
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 0;
    padding: .7rem .3rem;
  }
  .stats-item { flex: 1; padding: .1rem .2rem; gap: .1rem; }
  .stats-num {
    font-size: 1.15rem; font-weight: 900; color: #5B5FEF;
    opacity: 1; transform: none; /* no entrance offset on the compact card */
  }
  .stats-label { font-size: .62rem; color: #6B7280; }
  .stats-divider { display: block; width: 1px; height: auto; align-self: stretch; margin: .15rem 0; background: rgba(17,24,39,.08); }
}
</style>
